import _ from 'lodash';
import { ADD_TOAST_ID, DELETE_TOAST_ID, DELETE_ALL_TOAST_ID, } from '../actions/ToastActions';
const INITIAL_STATE = {
    toastIds: [],
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { toastId, type }) => {
    switch (type) {
        case ADD_TOAST_ID: {
            return Object.assign(Object.assign({}, state), { toastIds: _.uniq([...state.toastIds, toastId]) });
        }
        case DELETE_TOAST_ID: {
            return Object.assign(Object.assign({}, state), { toastIds: state.toastIds.filter((v) => v !== toastId) });
        }
        case DELETE_ALL_TOAST_ID: {
            return Object.assign(Object.assign({}, state), { toastIds: [] });
        }
        default: {
            return state;
        }
    }
};
